__turbopack_context__.v({
  "atcErrorNotification": "ProductDetailTemplate-module-scss-module__JXtanW__atcErrorNotification",
  "detailsColumn": "ProductDetailTemplate-module-scss-module__JXtanW__detailsColumn",
  "galleryColumn": "ProductDetailTemplate-module-scss-module__JXtanW__galleryColumn",
  "heroSection": "ProductDetailTemplate-module-scss-module__JXtanW__heroSection",
  "productDetailsSticky": "ProductDetailTemplate-module-scss-module__JXtanW__productDetailsSticky",
});
